import React from "react";
import { Link } from "react-router-dom";
import "./degree.scss";
import Table from "react-bootstrap/Table";
import Image1 from "../../assets/images/building.jpg";
import Image2 from "../../assets/images/lib2.jpg";
import Image3 from "../../assets/images/cs.webp";
export const DegreeStructure = () => {
  return (
    <>
      <div className="degree-page">
        <center>
          <h1>degree structure</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>About</h6>
        </div>
      </div>
      <center>
        {" "}
        <div className="col-md-6 mtt">
          <p>
            The department in conjunction with the University of Port Harcourt
            runs a four (4) year degree programme leading to the award of
            Bachelor of Sciences (B Sc) Degrees in Physics in the following
            options:
          </p>
          <ul className="list-unstyled">
            <li>Applied Physics</li>
            <li>Physics with Electronics</li>
            <li>Physics with Materials Science</li>
            <li>Physics with Applied Geophysics.</li>
          </ul>
        </div>
      </center>
      <div className="offset-md-2 col-md-8 mt6 ">
        <center>
          <h3>The General framework for the degree structure is as follows:</h3>
        </center>
        <div className="flexy">
          <div className="col-md-6 mt5" style={{ padding: "5px" }}>
            {" "}
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>1st Year</th>
                  <th>3rd Year</th>
                </tr>{" "}
                <tr>
                  <th>General Studies Courses</th>
                  <th>General Studies Courses</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>(Where Foundation Courses applicable)</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Major Courses</td>
                  <td>Major Courses</td>
                </tr>
                <tr>
                  <td>Elective Courses (if any)</td>
                  <td>
                    <strong>Industrial (2nd semester)</strong>
                  </td>
                </tr>{" "}
              </tbody>
            </Table>
          </div>
          <div className="col-md-6 mt5" style={{ padding: "5px" }}>
            {" "}
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Training/Attachment</th>
                  <th></th>
                </tr>{" "}
                <tr>
                  <th>2nd Year</th>
                  <th>4th Year</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>General Studies Courses (where applicable)</td>
                  <td>General Studies Courses (where applicable)</td>
                </tr>
                <tr>
                  <td>Foundation Courses</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Major Courses</td>
                  <td>Major Courses</td>
                </tr>{" "}
                <tr>
                  <td>Community service Courses (where applicable)</td>
                  <td>Elective Courses (where applicable)</td>
                </tr>{" "}
                <tr>
                  <td>Elective courses (where applicable)</td>
                  <td>Seminar courses (where applicable)</td>
                </tr>{" "}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="flexy mt9">
          <div className="col-md-6">
            <h5>General Studies Courses</h5>
            <p>
              These are courses at appropriate levels of the degree programme,
              the purpose of which shall be to improve the basic intellectual
              and communications skills of the students and to promote a
              continuous awareness and understanding of contemporary society as
              well as the historical and cultural origins of the peoples of
              Nigeria.
            </p>
            <h5>Foundation Studies Course</h5>
            <p>
              A common core courses in the Science Faculty from which all
              students shall take an approved selection in at least the first
              year, the purpose of which shall be to provide a sound background
              in general principles and methodology relating to the disciplines
              in the faculty.
            </p>
          </div>
          <div className="col-md-6">
            {" "}
            <img className="" src={Image1} alt="Scholar" width="100%" />
          </div>
        </div>{" "}
        <div className="flexy mt9">
          <div className="col-md-6">
            {" "}
            <img className="" src={Image3} alt="Scholar" width="97%" />
          </div>
          <div className="col-md-6 mobile-padding">
            <h5>Community Service Course</h5>
            <p>
              This field project is directed towards service to the community or
              to the University and is an integral part of all degree
              programmes. The objective of the project is to involve both staff
              and students in a practical way with some of the problems of
              society as well as with efforts to provide solutions to them, and
              to inculcate and develop in both staff and students a
              consciousness of their responsibilities to society and the
              satisfaction of rendering service to others. The projects, which
              are practical in nature, require the application of some of the
              skills being acquired in the degree programme to service of the
              community, and generally involve manual work. They are credit
              earning and are an essential requirement in all degree programmes.
            </p>
            <h5>Major Courses</h5>
            <p>
              These are courses in the student’s major field of interest. These
              shall begin as a limited number of major courses in the first two
              years, and occupy most of the student’s time in subsequent years.
            </p>
          </div>
        </div>
        <div className="flexy mt9 mobile-padding">
          <div className="col-md-6">
            <h5>Elective Courses</h5>
            <p>
              Elective courses offer some opportunities to student to broaden
              their interests, either within or outside their major discipline,
              subject to the advice of their academic advisers; students are
              encouraged to follow their interests in electives.
            </p>
            <h5>Industrial Attachment</h5>
            <p>
              Students are expected to undergo a six-month period of industrial
              attachment. This is usually at the second semester of the 300
              levels or year of the programme.
            </p>
          </div>
          <div className="col-md-6">
            {" "}
            <img className="" src={Image2} alt="Scholar" width="100%" />
          </div>
        </div>{" "}
        <center className="mt">
          <Link to={"/course-page"} className="courses-link">
            Go to Courses{" "}
          </Link>
        </center>
        <h5 className="mt7">GENERAL REQUIREMENTS FOR AWARD OF A DEGREE</h5>
        <div className="col-md-10 mt3 mobile-padding">
          <h6>Programme</h6>
          <p>
            To obtain a degree in Physics of the University of Port Harcourt,
            students must complete the approved programme of study and pass all
            the prescribed courses.
          </p>
          <p>
            The pass mark for each course in the undergraduate programme is 40%.
            In addition a student must end accumulative credit unit between 120
            and 192. That is a minimum of 15 credit units and a maximum 24
            credit units per semester. The duration of the programme is 4
            academic years to a maximum of 6 academic years. Candidates who
            spend maximum of 6 years in the programme shall either pass or fail
            out.
          </p>
        </div>
        <div className="d-md-flex mobile-padding">
          <div className="col-md-6 mt" style={{ padding: "5px" }}>
            <h6>GRADING SYSTEM</h6>
            <p>
              The following system of Grade Points shall be used for all
              students:
            </p>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th colSpan={3}>
                    <center>NEW STUDENTS</center>
                  </th>
                </tr>
                <tr>
                  <th>MARK SCORE</th>
                  <th>LETTER NOTATION</th>
                  <th>GRADE POINT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>70% & above</td>
                  <td>A</td>
                  <td>5.00</td>
                </tr>{" "}
                <tr>
                  <td>60-69</td>
                  <td>B</td>
                  <td>4.00</td>
                </tr>
                <tr>
                  <td>50-59</td>
                  <td>C</td>
                  <td>3.00</td>
                </tr>
                <tr>
                  <td>45-49</td>
                  <td>D</td>
                  <td>2.00</td>
                </tr>
                <tr>
                  <td>40-44</td>
                  <td>E</td>
                  <td>1.00</td>
                </tr>{" "}
                <tr>
                  <td>0-39</td>
                  <td>F</td>
                  <td>0.00</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="col-md-6 mt" style={{ padding: "5px" }}>
            <h6>CLASSIFICATION OF DEGREES</h6>
            <p>
              The degree shall be awarded with <strong>1st</strong>,{" "}
              <strong>2nd Upper</strong>, <strong>2nd Lower</strong>, or{" "}
              <strong>3rd Class </strong> Honours degree. The Cumulative Grade
              Point Averages for these classes shall be
            </p>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>CLASS OF DEGREE</th>
                  <th colSpan={2}>CUMULATIVE GRADE POINT AVERAGE</th>
                </tr>
                <tr>
                  <td>1st Class</td>
                  <td>4.50 - 5.00</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2nd Class Upper</td>
                  <td>3.50 - 4.49</td>
                </tr>{" "}
                <tr>
                  <td>2nd Class Lower</td>
                  <td>2.40 - 3.49</td>
                </tr>
                <tr>
                  <td>3rd Class</td>
                  <td>1.50 – 2.39</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <p>
          Students are obliged to sit for examinations in all registered
          courses. Any student who fails to sit for a course examination without
          satisfactory reason and by written application earns the grade of “F”.
        </p>
        <br />
        <br />
        <h5>COMPUTATION OF GRADE POINT AVERAGE</h5>
        <p>
          Every course carries a fixed number of Credit Unit (CU). One credit
          Unit being when a class meets for one hour every week for one semester
          or three hours every week in the laboratory, workshop or field.
        </p>
        <p>
          Quality Points (QP) are derived by multiplying the Credit Unit for the
          course by the Grade Point earned by the student e.g., in a course with
          3 Credit Units in which a student earned a B with 4 Grade Points, the
          Quality Points are 3 x 4 = 12
        </p>
        <p>
          Grade Point Average (GPA) is derived by dividing the Quality Points
          for the se­mester by the Credit Units for the semester e.g., in a
          semester where the student earned 56 Quality Points for 18 Credit
          Units, the GPA is 56 ÷ 18 = 3.11
        </p>
        <p>
          Cumulative Grade Point Average (CGPA) is derived by adding the Total
          Quality Points (TQP) to date and dividing by the Total Credit Units
          (TCU) to date e.g., if the TQP are 228 and the TUC are 68, then the
          CGPA is 228 ÷ 68 = 3.35.
        </p>
        <p>
          Detailed example of how to calculate GPA and CGPA is shown on the next
          page.
        </p>
        <h5>FIRST YEAR, SEMESTER ONE</h5>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>COURSE</th>
              <th>Credit Units</th>
              <th>Letter Grade</th>
              <th>Grade Points</th>
              <th>Quality Points</th>
              <th>Grade Point Average (GPA)</th>
              <th>Cumulative Grade point Average (CGPA)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>APC 100</td>
              <td>3</td>
              <td>B</td>
              <td>4</td>
              <td>12</td>
              <td>QP=66 CU=17 GPA=66 ÷17 = 3.88</td>
              <td>TQP =66 TCU = 17 CGPA = 60÷17 = 3.88</td>
            </tr>{" "}
            <tr>
              <td>APC 101</td>
              <td>2</td>
              <td>C</td>
              <td>3</td>
              <td>6</td>
            </tr>
            <tr>
              <td>APC 102</td>
              <td>1</td>
              <td>C</td>
              <td>3</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>APC 103</td>
              <td>4</td>
              <td>B</td>
              <td>4</td>
              <td>16</td>
            </tr>{" "}
            <tr>
              <td>APC 104</td>
              <td>5</td>
              <td>D</td>
              <td>2</td>
              <td>2</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <td>TOTAL</td>
              <td>17</td>
              <td></td>
              <td></td>
              <td>66</td>
            </tr>
          </thead>
        </Table>
        <br />
        <h5>FIRST YEAR, SEMESTER TWO</h5>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>COURSE</th>
              <th>Credit Units</th>
              <th>Letter Grade</th>
              <th>Grade Points</th>
              <th>Quality Points</th>
              <th>Grade Point Average (GPA)</th>
              <th>Cumulative Grade point Average (CGPA)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>APC 106</td>
              <td>5</td>
              <td>E</td>
              <td>1</td>
              <td>5</td>
              <td>QP=48 CU=20 GPA 48÷20= 2.40</td>
              <td>TQP =114 TCU = 37 CGPA = 66÷17 = 3.88</td>
            </tr>{" "}
            <tr>
              <td>APC 107</td>
              <td>4</td>
              <td>D</td>
              <td>2</td>
              <td>8</td>
            </tr>
            <tr>
              <td>APC 108</td>
              <td>5</td>
              <td>B</td>
              <td>4</td>
              <td>20</td>
            </tr>{" "}
            <tr>
              <td>APC 109</td>
              <td>3</td>
              <td>F</td>
              <td>0</td>
              <td>0</td>
            </tr>{" "}
            <tr>
              <td>APC 110</td>
              <td>3</td>
              <td>A</td>
              <td>5</td>
              <td>15</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <td>TOTAL</td>
              <td>20</td>
              <td></td>
              <td></td>
              <td>48</td>
            </tr>
          </thead>
        </Table>
      </div>
      <div className="table-div">
        <div className="col-md-8 offset-md-2">
          {" "}
          <br />
          <h5>SECOND YEAR, SEMESTER ONE</h5>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>COURSE</th>
                <th>Credit Units</th>
                <th>Letter Grade</th>
                <th>Grade Points</th>
                <th>Quality Points</th>
                <th>Grade Point Average (GPA)</th>
                <th>Cumulative Grade point Average (CGPA)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>APC 210</td>
                <td>2</td>
                <td>E</td>
                <td>1</td>
                <td>12</td>
                <td>QP=61 CU=18 GPA 61÷18= 3.18</td>
                <td>TQP =175 TCU = 55 CGPA=175÷55 = 3.18</td>
              </tr>{" "}
              <tr>
                <td>APC 211</td>
                <td>3</td>
                <td>C</td>
                <td>3</td>
                <td>9</td>
              </tr>
              <tr>
                <td>APC 212</td>
                <td>5</td>
                <td>B</td>
                <td>4</td>
                <td>20</td>
              </tr>{" "}
              <tr>
                <td>APC 213</td>
                <td>5</td>
                <td>C</td>
                <td>3</td>
                <td>15</td>
              </tr>{" "}
              <tr>
                <td>APC 214</td>
                <td>3</td>
                <td>A</td>
                <td>5</td>
                <td>15</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <td>TOTAL</td>
                <td>18</td>
                <td></td>
                <td></td>
                <td>61</td>
              </tr>
            </thead>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt6">
        {" "}
        <br />
        <h5>SECOND YEAR, SEMESTER TWO</h5>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>COURSE</th>
              <th>Credit Units</th>
              <th>Letter Grade</th>
              <th>Grade Points</th>
              <th>Quality Points</th>
              <th>Grade Point Average (GPA)</th>
              <th>Cumulative Grade point Average (CGPA)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>APC 215</td>
              <td>3</td>
              <td>B</td>
              <td>4</td>
              <td>12</td>
              <td>QP=59 CU=20 GPA 59÷20= 2.95</td>
              <td>TQP =234 TCU = 75 CGPA= 7234÷55 = 3.12</td>
            </tr>{" "}
            <tr>
              <td>APC 216</td>
              <td>4</td>
              <td>C</td>
              <td>3</td>
              <td>12</td>
            </tr>
            <tr>
              <td>APC 217</td>
              <td>5</td>
              <td>B</td>
              <td>4</td>
              <td>20</td>
            </tr>{" "}
            <tr>
              <td>APC 218</td>
              <td>2</td>
              <td>F</td>
              <td>0</td>
              <td>0</td>
            </tr>{" "}
            <tr>
              <td>APC 219</td>
              <td>3</td>
              <td>D</td>
              <td>2</td>
              <td>15</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <td>TOTAL</td>
              <td>20</td>
              <td></td>
              <td></td>
              <td>59</td>
            </tr>
          </thead>
        </Table>
        <p>
          Observe how the course APC 109 was failed in Year 1, Semester 2, and
          computed with F = 0 Year 1. It was then registered and computed with D
          = 2 in Year II, Se­mester 2. The old grade is not replaced by the new
          one.
        </p>
        <p>
          Grades obtained in all approved courses of a student’s prescribed
          programme, excluding audited courses shall be used to compute the GPA.
        </p>
        <p>
          With the reduction in Total Credit Units for graduation as directed by
          NUC and Senate no student is allowed to over register for courses.
        </p>
        <p>
          When a student was registered for a course but the result is
          unavailable, due to no fault of the student, no result will be
          recorded for that course and the student will re-register for it in
          the next academic Year.
        </p>
        <p>
          When a student transfers from one Faculty to another, only the grades
          obtained in the courses in the new prescribed programme of study will
          be used to compute the CGPA. Courses which were completed before the
          change of programme and which are not part of the prescribed programme
          will be treated as audited courses.
        </p>
      </div>
      <div className="layout">
        <div className="col-md-8 offset-md-2">
          <center>
            <h2>COURSE LAYOUT </h2>
          </center>
          <div className="d-flex mt5">
            <h4 style={{ flexGrow: 1 }}>YEAR ONE:</h4>
            <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Course Code</th>
                <th> Title</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>CHM 130.1</td>
                <td>General Chemistry</td>
                <td>3</td>
              </tr>
              <tr>
                <td>GES 100.1</td>
                <td>Communication Skill in Eng.</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>GES 102.1</td>
                <td>Intro. To Logic & Philosophy</td>
                <td>2</td>
              </tr>
              <tr>
                <td>MTH 110.1</td>
                <td>Algebra & Trigonometry</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>MTH 120.1</td>
                <td>Coordinate Geometry/Calculus</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 101.1</td>
                <td>Introduction to Mech.& Properties of Matter</td>
                <td>3</td>
              </tr>
              <tr>
                <td>PHY 101.1</td>
                <td>Introduction to Mech.& Properties of Matter</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 102.1</td>
                <td>Laboratory Practice 1</td>
                <td>1</td>
              </tr>{" "}
              <tr>
                <td>FSB 101.1</td>
                <td>General Biology I</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td></td>
                <td>
                  <strong>Total Units</strong>
                </td>
                <td>
                  <strong>21</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt">
        <center>
          <h3>Second Semester </h3>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>CHM 131.2</td>
              <td>General Chemistry</td>
              <td>3</td>
            </tr>
            <tr>
              <td>GES 101.2</td>
              <td>Computer Appreciation and Appreciation .</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>GES 103.2</td>
              <td>Nigerian People & Culture</td>
              <td>2</td>
            </tr>
            <tr>
              <td>GLY 101.2</td>
              <td>Planet Earth</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>GLY 102.2</td>
              <td>Introduction to Lab/Field Practice in Geology</td>
              <td>1</td>
            </tr>{" "}
            <tr>
              <td>MTH 124.2</td>
              <td>Coordinate Geometry</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 103.2</td>
              <td>Laboratory Practice II</td>
              <td>1</td>
            </tr>{" "}
            <tr>
              <td>PHY 112.2</td>
              <td>Introduction to Electricity & Magnetism</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>FSB 102.2</td>
              <td>General Biology II</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className="layout">
        <div className="col-md-8 offset-md-2">
          <div className="d-flex mt5">
            <h4 style={{ flexGrow: 1 }}>YEAR TWO: </h4>
            <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Course Code</th>
                <th> Title</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>CSC 280.1</td>
                <td>Computer Programming</td>
                <td>3</td>
              </tr>
              <tr>
                <td>MTH 210.1</td>
                <td>Linear Algebra.</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 206.1</td>
                <td>Laboratory Practice III</td>
                <td>1</td>
              </tr>
              <tr>
                <td>PHY 210.1</td>
                <td>Physics of the Solid Earth</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 216.1</td>
                <td>Vibrations & Waves</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>STA 260.1</td>
                <td>Introduction to Probability & Statistics</td>
                <td>3</td>
              </tr>
              <tr>
                <td>PHY 231.1</td>
                <td>Modern Physics</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>SLT 201.1 </td>
                <td>Photography and Illustration</td>
                <td>1</td>
              </tr>{" "}
              <tr>
                <td></td>
                <td>
                  <strong>Total Units</strong>
                </td>
                <td>
                  <strong>18</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt6">
        <center>
          <h3>Second Semester </h3>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 200.2</td>
              <td>Energy, Environment and Space Science</td>
              <td>2</td>
            </tr>
            <tr>
              <td>MTH 240.2</td>
              <td>Vector Analysis</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>MTH 250.2</td>
              <td>Elem. Differential Equation</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 205.2</td>
              <td>Thermal Physics</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 207.2</td>
              <td>Laboratory practice IV</td>
              <td>1</td>
            </tr>{" "}
            <tr>
              <td>PHY 211.1</td>
              <td>Quantum Mechanics I</td>
              <td>2</td>
            </tr>
            <tr>
              <td>PHY 221.2</td>
              <td>Mathematical Physics</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 222.2</td>
              <td>Analytical mechanics I</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>SLT 210.2</td>
              <td>Workshop Technology II (Glass Blowing)</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>20</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>{" "}
      <div className="col-md-8 offset-md-2 ">
        <center>
          <h5> ELECTIVES (OPTIONAL) </h5>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>GLY 201.1</td>
              <td>Stratigraphy & Historical Geology</td>
              <td>2</td>
            </tr>
            <tr>
              <td>GLY 202.1</td>
              <td>Structural Geology</td>
              <td>2</td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>
      <div className="layout">
        <div className="col-md-8 offset-md-2">
          <center>
            <h3>B.Sc. PHYSICS/APPLIED GEOPHYSICS PROGRAM</h3>
          </center>
          <div className="d-flex mt5">
            <h4 style={{ flexGrow: 1 }}>YEAR THREE: </h4>
            <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Course Code</th>
                <th> Title</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>GES 300.1</td>
                <td>Entrepreneurship </td>
                <td>2</td>
              </tr>
              <tr>
                <td>PHY 300.1</td>
                <td>Mathematical Physics II</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 313.1</td>
                <td>Electricity & Magnetism I</td>
                <td>2</td>
              </tr>
              <tr>
                <td>PHY 322.1</td>
                <td>Analytical Physics II</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 331.1</td>
                <td>Quantum Mechanics II</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 351.1</td>
                <td>Electronics I</td>
                <td>2</td>
              </tr>
              <tr>
                <td>PHY 361.1</td>
                <td>Introduction to Applied Geophysics</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 362.1 </td>
                <td>Geophysical Exploration I</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td></td>
                <td>
                  <strong>Total Units</strong>
                </td>
                <td>
                  <strong>16</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt1">
        <center>
          <h4> SECOND SEMESTER </h4>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 350.2</td>
              <td>Industrial Training</td>
              <td>9</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>9</strong>
              </td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>
      <div className="col-md-8 offset-md-2 mt">
        <div className="d-flex mt5">
          <h4 style={{ flexGrow: 1 }}>YEAR FOUR: </h4>
          <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
        </div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>GES 400.1</td>
              <td>Entrepreneurship II</td>
              <td>2</td>
            </tr>
            <tr>
              <td>PHY 408.1</td>
              <td>Computational Physics & Numerical Methods</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 409.1</td>
              <td>Physical Optics</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 412.1</td>
              <td>Technical Writing</td>
              <td>1</td>
            </tr>{" "}
            <tr>
              <td>PHY 414.1</td>
              <td>Elect. & Magnetism II</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 435.1</td>
              <td>Mechanical properties of Materials</td>
              <td>2</td>
            </tr>
            <tr>
              <td>PHY 442.1</td>
              <td>Solid State Physics I</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 444.1</td>
              <td>Engineering Materials</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 452.1</td>
              <td>Electronics II</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>{" "}
      <div className="layout">
        <div className="col-md-8 offset-md-2">
          <center>
            <h3>SECOND SEMESTER</h3>
          </center>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Course Code</th>
                <th> Title</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PHY 434.2</td>
                <td>Atomic & Nuclear Physics </td>
                <td>3</td>
              </tr>
              <tr>
                <td>PHY 436.2</td>
                <td>Powder Metallurgy & Ceramics</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 441.2</td>
                <td>Modern Materials and Trends</td>
                <td>2</td>
              </tr>
              <tr>
                <td>PHY 443.2</td>
                <td>Solid State Physics II</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 449.2</td>
                <td>Project Work</td>
                <td>6</td>
              </tr>{" "}
              <tr>
                <td>PHY 450.2</td>
                <td>Seminar</td>
                <td>3</td>
              </tr>
              <tr>
                <td>PHY 361.1</td>
                <td>Introduction to Applied Geophysics</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 490.2 </td>
                <td>Statistical Physics</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td></td>
                <td>
                  <strong>Total Units</strong>
                </td>
                <td>
                  <strong>22</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2">
        <center>
          <h4>ELECTIVES (OPTIONAL)</h4>
        </center>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 418.2</td>
              <td>Meteorology </td>
              <td>2</td>
            </tr>
            <tr>
              <td>PHY 420.2</td>
              <td>Modern Cosmology and High Energy Astrophysics</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 411.2</td>
              <td>Applied Geophysics for non-Geophysics Majors</td>
              <td>2</td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>{" "}
      <div className="col-md-8 offset-md-2 mt">
        <center>
          <h4>EB.Sc. PHYSICS PROGRAM</h4>
        </center>
        <div className="d-flex mt5">
          <h4 style={{ flexGrow: 1 }}>YEAR THREE: </h4>
          <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
        </div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>GES 300.1</td>
              <td>Entrepreneurship </td>
              <td>2</td>
            </tr>
            <tr>
              <td>MTH 324.1</td>
              <td>Complex Analysis</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 300.1</td>
              <td>Mathematical Physics II</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 313.1</td>
              <td>Electricity & Magnetism I</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 320.1</td>
              <td>Advanced Workshop</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 322.1</td>
              <td>Analytical Physics II</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 331.1</td>
              <td>Quantum Mechanics II</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 351.1</td>
              <td>Elect. Instrument I</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 351.1</td>
              <td>Electronics I</td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>19</strong>
              </td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>{" "}
      <div className="col-md-8 offset-md-2 mt">
        <center>
          <h4>SECOND SEMESTER </h4>
        </center>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 350.2 </td>
              <td>Industrial Training </td>
              <td>9</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>9</strong>
              </td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>{" "}
      <div className="layout">
        <div className="col-md-8 offset-md-2">
          <div className="d-flex mt5">
            <h4 style={{ flexGrow: 1 }}>YEAR FOUR: </h4>
            <h4 style={{ flexGrow: 1 }}> FIRST SEMESTER</h4>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Course Code</th>
                <th> Title</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>GES 400.1</td>
                <td>Entrepreneurship </td>
                <td>2</td>
              </tr>
              <tr>
                <td> PHY 408.1 </td>
                <td>Computational Physics</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 409.1</td>
                <td>Technical Writing</td>
                <td>1</td>
              </tr>
              <tr>
                <td>PHY 414.1</td>
                <td>Elect & Magnetism II</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 435.1</td>
                <td>Mechanical properties of Materials</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td>PHY 442.1</td>
                <td>Solid State Physics I</td>
                <td>3</td>
              </tr>
              <tr>
                <td>PHY 452.1</td>
                <td>Electronics II</td>
                <td>3</td>
              </tr>{" "}
              <tr>
                <td>PHY 455.1 </td>
                <td>Electronics Instrumentation I</td>
                <td>2</td>
              </tr>{" "}
              <tr>
                <td></td>
                <td>
                  <strong>Total Units</strong>
                </td>
                <td>
                  <strong>21</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mt6">
        <center>
          <h4>SECOND SEMESTER </h4>
        </center>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 434.2 </td>
              <td>Atomic & Nuclear Physics </td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 443.2</td>
              <td>Solid State Physics II </td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 449.2</td>
              <td>Project work</td>
              <td>6</td>
            </tr>{" "}
            <tr>
              <td>PHY 450.2</td>
              <td>Seminar</td>
              <td>3</td>
            </tr>{" "}
            <tr>
              <td>PHY 454.2</td>
              <td>Microwaves</td>
              <td>3</td>
            </tr>
            <tr>
              <td>PHY 490.2</td>
              <td>Statistical Physics</td>
              <td>3</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Total Units</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>{" "}
      <div className="col-md-8 offset-md-2">
        <center>
          <h4>ELECTIVES (OPTIONAL) </h4>
        </center>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Code</th>
              <th> Title</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PHY 418.2</td>
              <td>Meteorology </td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 420.2</td>
              <td>Modern Cosmology and High Energy Astrophysics </td>
              <td>2</td>
            </tr>{" "}
            <tr>
              <td>PHY 411.2</td>
              <td>Applied Geophysics for non-Geophysics Majors</td>
              <td>2</td>
            </tr>{" "}
          </tbody>
        </Table>
      </div>{" "}
    </>
  );
};
